import { useState } from "react";
import { CancelAmountRowProps, CancelPriceModel } from "../types";
import { numberToStringWithComma, ViewYmdFormat } from "src/utils/common-util";
import moment from "moment";

// 취소 금액 행 컴포넌트
// 취소 금액 정보를 빨간색으로 표시하는 행 컴포넌트

export const CancelAmountRow = ({ label, contractCancelList, totalPaymentAmount }: CancelAmountRowProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const cancelAmountSum = contractCancelList?.reduce((a: number, b: any, c: any) => a + b.cancelAmount, 0);
  const actualPaymentAmount = totalPaymentAmount - cancelAmountSum;
  return (
    <>
      <div className="base-section-layout-line">
        {/* 라벨 표시 */}
        <p className="base-section-layout-index text-primary3">{label}</p>
        <div className={`cancel-payment-list ${isOpen ? "--active" : ""}`} onClick={() => setIsOpen(!isOpen)}>
          {/* 총계 여부에 따른 스타일 적용 */}
          <span className="base-section-layout-value totalPrice text-red font15">-{numberToStringWithComma(cancelAmountSum)}</span>
          <span className="font15 text-red"> 원</span>
        </div>
      </div>
      {isOpen && (
        <div className="cancel-payment-list-content">
          {contractCancelList?.map((item: CancelPriceModel) => (
            <div key={item.cancelId} className="flex-center-between">
              <p>{moment(item.cancelDate).format(ViewYmdFormat.YYYY_MM_DD_HH_MM)}</p>
              <p>- {numberToStringWithComma(item.cancelAmount)} 원</p>
            </div>
          ))}
        </div>
      )}
      <div className="horizontal-divider" />
      <div className="total-cancel-count">
        <p className="text-primary1 font-weight-600 font16">실제 결제 금액</p>
        <p className="text-primary1 font-weight-700 font20">
          {numberToStringWithComma(actualPaymentAmount)} <span className="font15 font-weight-400">원</span>
        </p>
      </div>
    </>
  );
};
